"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAutoFocus = void 0;
const react_1 = require("react");
function useAutoFocus(autoFocus, disabled) {
    const autoFocusRef = react_1.useRef(null);
    react_1.useEffect(() => {
        requestAnimationFrame(() => {
            if (autoFocusRef && autoFocusRef.current && autoFocus && !disabled) {
                autoFocusRef.current.focus();
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [disabled]);
    return { autoFocusRef };
}
exports.useAutoFocus = useAutoFocus;
//# sourceMappingURL=auto-focus-hook.js.map